import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/20/solid'
import { FunnelIcon } from '@heroicons/react/24/outline'

export default function SearchBar({
    placeholder,
    searchTerm,
    setSearchTerm,
    showFiltersToggle = true,
    showFilters = null,
    setShowFilters = null
}) {
    return (
        <div className="flex items-center gap-x-4">
            <div className="flex-grow relative">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>

                <input
                    type="text"
                    className="w-full py-2 pl-10 pr-16 rounded-md border border-gray-200 bg-white shadow-md placeholder-gray-500 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400"
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={(event) => setSearchTerm(event.target.value)}
                />

                {searchTerm && (
                    <div 
                        className={`
                            absolute inset-y-0 right-0 flex items-center  cursor-pointer
                            ${showFiltersToggle === true ? 'pr-10' : 'pr-3'}
                        `} 
                        onClick={() => setSearchTerm('')}
                    >
                        <XMarkIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                )}

                {showFiltersToggle === true && showFilters !== null && setShowFilters !== null && 
                    <div 
                        className="absolute inset-y-0 right-0 flex items-center pr-4 cursor-pointer"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <FunnelIcon className="h-4 w-4 text-gray-400" aria-hidden="true" />
                    </div>
                }
            </div>
        </div>
    )
}